export default "__VITE_ASSET__e729f44a__"